import React, { useState } from 'react';
import FileUploader from '../components/FileUploader';
import ProcessingIndicator from '../components/ProcessingIndicator';
import { rotateImage } from '../utils/imageUtils';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import './ToolPage.css';

const ImageRotate = () => {
    const [files, setFiles] = useState([]);
    const [processing, setProcessing] = useState(false);
    const [degrees, setDegrees] = useState(90);
    const [processedFiles, setProcessedFiles] = useState([]);

    const handleFilesSelected = (selectedFiles) => {
        setFiles(selectedFiles);
        setProcessedFiles([]);
    };

    const handleRotate = async () => {
        if (files.length === 0) return;

        setProcessing(true);
        const rotated = [];

        try {
            for (const file of files) {
                const rotatedFile = await rotateImage(file, degrees);
                rotated.push(rotatedFile);
            }
            setProcessedFiles(rotated);
        } catch (error) {
            alert('Rotation failed: ' + error.message);
        } finally {
            setProcessing(false);
        }
    };

    const handleDownload = async () => {
        if (processedFiles.length === 1) {
            saveAs(processedFiles[0], processedFiles[0].name);
        } else {
            const zip = new JSZip();
            processedFiles.forEach((file) => {
                zip.file(file.name, file);
            });
            const content = await zip.generateAsync({ type: 'blob' });
            saveAs(content, 'rotated_images.zip');
        }
    };

    return (
        <div className="tool-page">
            <div className="tool-header">
                <h1>🔄 Image Rotate</h1>
                <p>Rotate images, supports 90°, 180°, 270° rotation</p>
            </div>

            <div className="tool-content">
                <FileUploader
                    accept="image/*"
                    onFilesSelected={handleFilesSelected}
                    title="Upload Images"
                />

                {files.length > 0 && !processing && processedFiles.length === 0 && (
                    <div className="tool-controls">
                        <div className="rotation-options">
                            {[90, 180, 270].map((deg) => (
                                <button
                                    key={deg}
                                    className={`rotation-btn ${degrees === deg ? 'active' : ''}`}
                                    onClick={() => setDegrees(deg)}
                                >
                                    {deg}°
                                </button>
                            ))}
                        </div>
                        <button className="btn btn-primary" onClick={handleRotate}>
                            Rotate Images
                        </button>
                    </div>
                )}

                {processing && <ProcessingIndicator message="Rotating images..." />}

                {processedFiles.length > 0 && (
                    <div className="results">
                        <h3>Rotation Complete!</h3>
                        <p>Successfully rotated {processedFiles.length} image(s)</p>
                        <button className="btn btn-primary" onClick={handleDownload}>
                            {processedFiles.length === 1 ? 'Download' : 'Download All'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ImageRotate;
